import { ForwardedRef, forwardRef } from 'react';
import { CSSObject, Global } from '@emotion/react';
import { useTokens } from '@gemini/core';
import { Tokens } from '@gemini/tokens';
import { default as icons } from '@mfe-presentation/assets/svg/portals/common/sprite.svg';
import { default as frenchIcons } from '@mfe-presentation/assets/svg/portals/french/sprite.svg';
import { useAppContext } from '@mfe-presentation/contexts';
import { IIconProps } from '@mfe-types/icon';
import { isFrenchPortal } from '@mfe-helpers/portalHelpers';

const svgStyles = (tokens: Tokens): CSSObject => ({
    svg: {
        '--border-active-default-color': tokens['color.border.active.default'],
    },
});

const Icon = forwardRef(
    (
        { name, title, marginBottom, children, ...rest }: IIconProps,
        ref: ForwardedRef<SVGSVGElement>,
    ) => {
        const tokens = useTokens();
        const { portal } = useAppContext();
        return (
            <>
                {!children && <Global styles={() => svgStyles(tokens)} />}
                <svg
                    ref={ref}
                    data-testid="svg-element"
                    {...{ 'aria-hidden': children && title ? undefined : true }}
                    {...rest}
                    style={{ color: tokens['color.border.accent.light.default'] }}
                >
                    {/* inlined case (e.g: logo)*/}
                    {children && (
                        <>
                            {title && <title>{title}</title>}
                            {children}
                        </>
                    )}
                    {/* svg sprite case (e.g: branded icons with dynamic colors)*/}
                    {!children && (
                        <use href={`${isFrenchPortal(portal) ? frenchIcons : icons}#${name}`} />
                    )}
                </svg>
            </>
        );
    },
);

export default Icon;
